// extracted by mini-css-extract-plugin
module.exports = {"max-width-medium":"768px","container":"DetailsAsideLayout__container","detailsContent":"DetailsAsideLayout__detailsContent"};